<a [href]="promo?.url" target="_blank">
    <div class="as-pointer as-product-promo" [ngStyle]="{'background-image': 'url('+ promo?.route +')'}"></div>
</a>